<div class="msg-error" (click)="refreshRequested($event)">
    <div class="msg-error-image">
        <img src="assets/dashboard/link-broken@2x.png" alt="Ups! Tenemos un problema">
    </div>
    <span class="msg-error-title">Ups! Tenemos un problema</span>
    <a class="refresh">
        <i class="material-icons">refresh</i>
        <span>Recargar</span>
    </a>
</div>